import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { FlightsSummary } from './FlightsSummary/FlightsSummary.tsx';

import type { Moment } from 'moment-timezone';

type Props = {
  /** Every flight date set (date-only UTC). */
  dates: Moment[];
  onAddFlight: () => void;
  /** Formatted total budget. */
  total: string;
};

/** "Add flight" + "TOTAL SET: <first date> to <last date> | <budget>" (Figma 8734:1036, no "See calendar"). */
export function FlightSettingsFooter({ dates, onAddFlight, total }: Props) {
  const { formatMessage } = useIntl();

  return (
    <footer className="flightSettings__footer">
      <ButtonUI
        icon="fas fa-plus"
        onClick={onAddFlight}
        shape="squareRounded"
        size="medium"
        text={formatMessage({ defaultMessage: 'ADD FLIGHT', id: 'spc.flightSettings.button.addFlight' })}
        type="primary"
      />
      <FlightsSummary
        className="flightSettings__summary"
        dates={dates}
        subTitle={formatMessage({ defaultMessage: 'TOTAL SET:', id: 'spc.flightSettings.summary.title' })}
        total={total}
      />
    </footer>
  );
}
